import { getOrFetchOdspDriverManifest } from './OdspDriverManifestAccessors';
import { currentVersionKey } from './OdspDriverManifestType';
export async function getBundleUrlForEnvironment(environment) {
    const manifest = await getOrFetchOdspDriverManifest(environment);
    return getBundleUrlFromManifest(manifest);
}
export function getBundleUrlFromManifest(manifest) {
    return manifest.jsBaseUrl + '/' + manifest[currentVersionKey].index;
}
//# sourceMappingURL=getBundleUrl.js.map